export const GET_ANALYSIS = 'GET_ANALYSIS';
export const GET_STORY = 'GET_STORY';
export const BOOKSHARE_OAUTH = "https://auth.bookshare.org/v2/oauth/authorize";
export const GET_COMPREHENSION_CONVERSATIONS = 'GET_COMPREHENSION_CONVERSATIONS';
export const GET_COMPREHENSION_CONVERSATIONS_START = 'GET_COMPREHENSION_CONVERSATIONS_START';
export const GET_COMPREHENSION_CONVERSATIONS_ERROR = 'GET_COMPREHENSION_CONVERSATIONS_ERROR';